import templates from 'builder/scenes/SiteBuilder/CreateSiteDialog/templates';

/**
 * Returns true when a page version has fully loaded content from the server.
 * Checks the explicit loadState field first; falls back to sentinel identity
 * check for pages that pre-date the loadState field (backward compat).
 */
export const isContentLoaded = (pageVersion?: PageVersion): boolean => {
  if (!pageVersion) return false;
  if (pageVersion.loadState !== undefined)
    return pageVersion.loadState === 'loaded';
  return !!pageVersion.content && pageVersion.content !== templates[0].widgets;
};

/**
 * Filters out placeholder/unvisited pages that have not been fetched from the
 * server yet. Those pages hold `templates[0].widgets` as a sentinel value for
 * their content, so we exclude them from saves.
 */
export const filterValidPages = (pages: Array<Page>): Array<Page> =>
  pages.filter(
    page =>
      page.current &&
      page.current.id !== null &&
      // Defensive: ensure content exists before checking against the placeholder sentinel.
      page.current.content &&
      isContentLoaded(page.current)
  );
